export default __webpack_public_path__ + "static/media/help_2_main.87a4b6bf.gif";